import { render } from "./ActiveHospitals.vue?vue&type=template&id=7b490133"
import script from "./ActiveHospitals.vue?vue&type=script&lang=js"
export * from "./ActiveHospitals.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/hospitals/ActiveHospitals.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b490133"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b490133', __exports__)) {
    console.log('reload')
    api.reload('7b490133', __exports__)
  }
  
  module.hot.accept("./ActiveHospitals.vue?vue&type=template&id=7b490133", () => {
    console.log('re-render')
    api.rerender('7b490133', render)
  })

}


export default __exports__